import { render, staticRenderFns } from "./BPInput.vue?vue&type=template&id=13f38e42&"
import script from "./BPInput.vue?vue&type=script&lang=js&"
export * from "./BPInput.vue?vue&type=script&lang=js&"
import style0 from "./BPInput.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BPInput.vue"
export default component.exports